<template>
  <div>
    <!-- 添加控制按钮 -->
    <div v-if="render === '' && !isExporting" class="button-container" style="margin-bottom: 20px; padding: 20px; background: #f5f5f5;">
      <!-- <button v-if="!exportCompleted" @click="exportAll" style="margin-right: 10px; padding: 10px 20px; background: #007bff; color: white; border: none; border-radius: 4px; cursor: pointer;">导出所有</button> -->
      <!-- <button  @click="uploadImages" style="padding: 10px 20px; background: #28a745; color: white; border: none; border-radius: 4px; cursor: pointer;">上传图片</button> -->
      <input type="file" ref="fileInput" @change="handleFileChange" accept=".json" style="display: none;">
    </div>

    <div id="pic" v-if="render === ''">
      <div id="header">
        <div class="meng"></div>
        <img :src="file" crossorigin="anonymous" class="background" />
        <span>{{ subject }}</span>

        <img
            class="logo"
            src="./page/xhd_log.png"
        />
        <img class="byr-banner" src="./page/xhd-banner.png">
        <div class="text">
          <div style="text-align: center;">{{subjectE}}</div>
        </div>
      </div>
      <div style="
      position: absolute;
      top: 1476px;
      width: 1125px;
      border-bottom: 5px solid rgb(224, 224, 224);
      box-shadow: rgba(0, 0, 0, 0.1) 0px 5px 5px;">

      </div>
      <div id="tail">
        <div class="box">
          <div class="jiao1" />
          <div class="jiao2" />
          <div class="jiao3" />
          <div class="jiao4" />
          <div class="textbox">
            <p class="title">
              {{ title }}
            </p>
            <div class="line"></div>
            <div>
              <p style="display: inline-block;vertical-align: top;">
                涉及方向：
              </p>
              <p class="ide">
                {{ direction }}
              </p>
            </div>
            <p style="display: inline-block;vertical-align: top;">
              {{ '导师身份：' }}
            </p>
            <div class="ide">
              <p v-for="item in teacher" :key="item">{{ item }}</p>
            </div>

            <div class="bottom-section">
              <div class="text-content">
                <p>科研D计划 [<b>1V1</b>]</p>
                <div class="line"></div>
                <p class="ms">
                  <span style="color:#d5ad85"><b>1v1</b>定制开展 </span> |
                  学术入门 | 全年滚动报名
                </p>
              </div>
              <div class="qr-content">
                <div id="qrcode" />
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <img :src="render" v-else style="width:100%" />
  </div>
</template>

<script>
import subjects from './subject.json'
import QRCode from 'qrcodejs2'
import axios from '../axios'
import html2canvas from 'html2canvas'

export default {
  name: 'page2',
  data () {
    return {
      uploadUrl: `${axios.defaults.baseURL}/upload/`,
      subject: '',
      description: '一封专属导师推荐信 一封完整的科研报告 一次完整的科研经历',
      title: '',
      subjectE: '',
      direction: '',
      teacher: [],
      key: '',
      qrcode: '',
      url: '',
      OSS: process.env.VUE_APP_OSS,
      file: '',
      uuid: '',
      total: 0,
      num: 0,
      render: '',
      xhdList: [], // 存储XHD列表数据
      exportData: [], // 存储导出的数据
      isExporting: false, // 是否正在导出
      exportCompleted: false // 导出是否完成
    }
  },
  mounted () {
    this.uuid = this.$route.query.uuid
    
    // 如果有uuid参数，则加载单个XHD页面
    if (this.uuid) {
      this.loadSingleXhd()
    }
  },
  methods: {
    // 获取XHD列表
    async getXhdList() {
      try {
        console.log('正在调用 previews/xhd/list 接口...')
        const response = await axios.get('previews/xhd/list')
        console.log('接口响应:', response)
        console.log('响应数据:', response.data)
        
        // 处理返回的数据结构 {topics: [...]}
        const data = response.data.topics || response.data
        this.xhdList = data
        return data
      } catch (error) {
        console.error('获取XHD列表失败:', error)
        console.error('错误详情:', error.response)
        return []
      }
    },

    // 导出所有图片
    async exportAll() {
      try {
        this.isExporting = true
        this.exportCompleted = false
        
        console.log('🚀 开始导出所有图片...')
        const xhdList = await this.getXhdList()
        
        console.log('📋 获取到的XHD列表:', xhdList)
        console.log('📊 列表长度:', xhdList.length)
        
        if (!xhdList || xhdList.length === 0) {
          alert('没有获取到XHD数据，请检查接口是否正常')
          this.isExporting = false
          return
        }
        
        for (let i = 0; i < xhdList.length; i++) {
          const item = xhdList[i]
          const uuid = item.xhd_url.split('/').pop() // 从URL中提取UUID
          
          console.log(`[进度 ${i + 1}/${xhdList.length}] 正在处理: ${uuid}`)
          
          // 获取数据并生成图片
          await this.generateImage(uuid, item.id)
          
          console.log(`[进度 ${i + 1}/${xhdList.length}] 完成: ${uuid}`)
          
          // 添加延迟避免请求过快
          await new Promise(resolve => setTimeout(resolve, 1000))
        }
        
        // 保存到本地文件
        this.saveToFile()
        
        console.log('✅ 导出完成！共生成', this.exportData.length, '个图片')
        
        // 设置导出完成状态
        this.isExporting = false
        this.exportCompleted = true
        
      } catch (error) {
        console.error('导出失败:', error)
        alert('导出失败: ' + error.message)
        this.isExporting = false
      }
    },

    // 生成单个图片
    async generateImage(uuid, id) {
      try {
        // 获取数据
        const response = await axios.get('previews/get_xhd', {
          params: { uuid }
        })
        
        const data = response.data
        this.subject = data.tags[0]
        this.direction = data.tags.slice(1, 4).join(' | ')
        this.teacher = [data.identity]
        this.title = data.title
        this.uuid = uuid
        
        // 设置背景图片 - 从data中获取file字段
        this.file = data.file || ''
        console.log(`🖼️ 设置背景图片: ${this.file}`)
        
        // 设置样式
        this.set()
        
        // 等待DOM更新和样式应用
        await this.$nextTick()
        
        // 等待背景图片加载完成
        if (this.file) {
          await this.waitForImageLoad(this.file)
        }
        
        // 给样式应用一些时间
        await new Promise(resolve => setTimeout(resolve, 200))
        
        // 生成图片
        const canvas = await this.generateCanvas()
        const imageUrl = canvas.toDataURL('image/jpeg', 0.9)
        
        // 转换为文件并上传
        const file = this.dataURLtoFile(imageUrl, `${this.title}.png`)
        const formData = new FormData()
        formData.append('file', file)
        formData.append('uuid', uuid)
        formData.append('type', '')
        
        const uploadResponse = await axios.post('previews/upload', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        
        // 保存到导出数据
        this.exportData.push({
          id: id,
          xhd_img: uploadResponse.data.url
        })
        
        console.log(`✅ 图片 ${id} 生成完成: ${uploadResponse.data.url}`)
        
      } catch (error) {
        console.error(`生成图片 ${id} 失败:`, error)
      }
    },

    // 生成Canvas
    generateCanvas() {
      return new Promise((resolve) => {
        // 临时隐藏按钮容器
        const buttonContainer = document.querySelector('.button-container')
        const originalDisplay = buttonContainer ? buttonContainer.style.display : ''
        if (buttonContainer) {
          buttonContainer.style.display = 'none'
        }
        
        // 保存原始样式
        const picElement = document.querySelector('#pic')
        const originalPosition = picElement.style.position
        const originalTop = picElement.style.top
        const originalLeft = picElement.style.left
        const originalMargin = picElement.style.margin
        
        // 设置绝对定位，确保位置正确
        picElement.style.position = 'absolute'
        picElement.style.top = '0px'
        picElement.style.left = '0px'
        picElement.style.margin = '0px'
        
        document.body.style.width = '2024px'
        html2canvas(picElement, {
          useCORS: true,
          scrollY: 0,
          height: 2436,
          width: 1125,
          x: 0,
          y: 0
        }).then(canvas => {
          document.body.style.width = 'unset'
          
          // 恢复原始样式
          picElement.style.position = originalPosition
          picElement.style.top = originalTop
          picElement.style.left = originalLeft
          picElement.style.margin = originalMargin
          
          // 恢复按钮容器显示
          if (buttonContainer) {
            buttonContainer.style.display = originalDisplay
          }
          
          resolve(canvas)
        })
      })
    },

    // 将DataURL转换为File对象
    dataURLtoFile(dataurl, filename) {
      const arr = dataurl.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },

    // 保存到本地文件
    saveToFile() {
      const dataStr = JSON.stringify(this.exportData, null, 2)
      const dataBlob = new Blob([dataStr], { type: 'application/json' })
      const url = URL.createObjectURL(dataBlob)
      const link = document.createElement('a')
      link.href = url
      link.download = 'xhd_images.json'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
      
      console.log('导出完成，共生成', this.exportData.length, '个图片')
      alert(`导出完成！共生成 ${this.exportData.length} 个图片`)
      
      // 重置导出数据，为下次导出做准备
      this.exportData = []
    },

    // 上传图片
    uploadImages() {
      this.$refs.fileInput.click()
    },

    // 处理文件选择
    handleFileChange(event) {
      const file = event.target.files[0]
      if (!file) return
      
      const reader = new FileReader()
      reader.onload = async (e) => {
        try {
          const data = JSON.parse(e.target.result)
          await this.batchUpload(data)
        } catch (error) {
          console.error('解析JSON文件失败:', error)
          alert('JSON文件格式错误')
        }
      }
      reader.readAsText(file)
    },

    // 等待图片加载完成
    waitForImageLoad(src) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.crossOrigin = 'anonymous'
        img.onload = () => {
          console.log(`✅ 背景图片加载完成: ${src}`)
          resolve()
        }
        img.onerror = () => {
          console.warn(`⚠️ 背景图片加载失败: ${src}`)
          resolve() // 即使失败也继续，避免阻塞
        }
        img.src = src
      })
    },

    // 批量上传
    async batchUpload(data) {
      try {
        console.log('开始批量上传...')
        const response = await axios.post('previews/update_xhd_img', {
          data: data
        })
        
        console.log('批量上传完成:', response.data)
        alert('批量上传完成！')
        
      } catch (error) {
        console.error('批量上传失败:', error)
        alert('批量上传失败: ' + error.message)
      }
    },

    // 加载单个XHD页面
    async loadSingleXhd() {
      try {
        const response = await axios.get('previews/get_xhd', {
          params: {
            uuid: this.uuid
          }
        })
        
        Object.assign(this.$data, response.data)
        const data = response.data
        this.subject = data.tags[0]
        this.direction = data.tags.slice(1, 4).join(' | ')
        this.teacher = [data.identity]
        this.set()
        this.set()
        setTimeout(() => {
          this.exportx()
        }, 1000)
        
      } catch (error) {
        console.error('加载XHD数据失败:', error)
      }
    },

    set () {
      this.subjectE = subjects[this.subject]
      let s = this.subjectE
      document
          .querySelector('#header span')
          .setAttribute('style', `font-size:125px`)
      if (s.length > 7) {
        document
            .querySelector('#header span')
            .setAttribute('style', `font-size:125px`)
      }
      if (s.length > 9) {
        document
            .querySelector('#header span')
            .setAttribute('style', `font-size:125px`)

        document
            .querySelector('.text')
            .setAttribute('style', `font-size:125px`)
      }
      if (s.length > 11) {
        document
            .querySelector('#header span')
            .setAttribute('style', `font-size:125px`)
      }
      if (s.length > 13) {
        document
            .querySelector('#header span')
            .setAttribute('style', `font-size:125px;line-height: 85px;`)
      }
      if (s.length > 20) {
        document
            .querySelector('#header span')
            .setAttribute('style', `font-size:100px;line-height: 80px;`)
         document
            .querySelector('.text')
            .setAttribute('style', `font-size:85px`)
         document
            .querySelector('.title')
            .setAttribute('style', `font-size:55px`)
      }
      if (s.length > 30) {
        document
            .querySelector('#header span')
            .setAttribute('style', `font-size:90px;line-height: 72px;`)
        document
            .querySelector('.text')
            .setAttribute('style', `font-size:75px`)
         document
            .querySelector('.title')
            .setAttribute('style', `font-size:50px`)
      }

      let qrcode = `https://p.eliteqihang.com/xhd/` + this.uuid
      document.getElementById('qrcode').innerHTML = ''
      // eslint-disable-next-line no-new
      new QRCode('qrcode', {
        text: qrcode,
        width: 185, // 图像宽度
        height: 185, // 图像高度
        colorDark: '#000000', // 前景色
        colorLight: '#ffffff', // 背景色
        typeNumber: 4,
        correctLevel: QRCode.CorrectLevel.H
      })
    },

    exportx () {
      this.$nextTick(() => {
        document.body.style.width = '2024px'
        html2canvas(document.querySelector('#pic'), {
          useCORS: true,
          scrollY: 0,
          height: 2436
        }).then(canvas => {
          document.body.style.width = 'unset'
          this.render = canvas.toDataURL('image/jpeg', 0.9)
          let arr = this.render.split(',')
          let mime = arr[0].match(/:(.*?);/)
          // eslint-disable-next-line no-undef
          let bstr = atob(arr[1])
          let n = bstr.length
          let u8arr = new Uint8Array(n)
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n)
          }
          // eslint-disable-next-line no-undef
          let param = new FormData()
          param.append(
              'file',
              // eslint-disable-next-line no-undef
              new File([u8arr], `${this.title}.png`, { type: mime })
          )
          param.append('uuid', this.uuid)
          param.append('type', '')
          axios.post('previews/upload', param, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
              .then(res => {
                this.render = res.data.url
                window.parent.postMessage(`xhd?=${res.data.url}`, '*')
              })
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
* {
  font-family: PFBD;
}
#pic {
  /*font-weight: 600;*/
  width: 1125px;
  height: 2436px;
}
#header {
  height: 1125px;
  background-position: bottom;
  position: relative;
span {
  color: #fff;
  font-size: 185px;
  position: absolute;
  left: 69px;
  bottom: 800px;
  font-weight: bolder;
  line-height: 120px;
  font-family: LemonMilkbold;
  width: 800px;
}
.background {
  width: 1125px;
  height: 1475px;
  top: 0;
  position: absolute;
  z-index: -1;
}
.byr-banner {
  position: absolute;
  width: 1000px;
  left: 70px;
  top: 500px;
}
.logo {
  position: absolute;
  top: 56px;
  left: 650px;
  height: 90px;
}
.number {
  position: absolute;
  bottom: 0;
  right: 0;
  height: 1125px;
}
}
#tail {
  margin-top: 360px;
  padding: 60px;
  position: relative;
  height: 920px;
  box-sizing: border-box;
> img {
  position: absolute;
  top: -44px;
  left: -45px;
}
}
.box {
  padding: 60px 60px;
  height: 800px;
  position: relative;
  box-sizing: border-box;
}
.jiao1 {
  border-left: 20px solid #000;
  border-top: 20px solid #000;
  width: 40px;
  height: 40px;
  left: 0;
  top: 0;
  position: absolute;
}
.jiao2 {
  border-right: 20px solid #000;
  border-top: 20px solid #000;
  width: 40px;
  height: 40px;
  right: 0;
  top: 0;
  position: absolute;
}
.jiao3 {
  border-left: 20px solid #000;
  border-bottom: 20px solid #000;
  width: 40px;
  height: 40px;
  left: 0;
  bottom: 0;
  position: absolute;
}
.jiao4 {
  border-right: 20px solid #000;
  border-bottom: 20px solid #000;
  width: 40px;
  height: 40px;
  right: 0;
  bottom: 0;
  position: absolute;
}
.textbox {
p {
  font-size: 48px;
  line-height: 56px;
  font-weight: normal;
}
.title {
  font-size: 56px;
  line-height: 60px;
  min-height: 120px;
  font-weight: normal;
}
}

.line {
  width: 100px;
  border-top: 5px solid #000;
  margin: 20px 0;
}
b {
  font-family: LemonMilkbold;
}

.bottom-section {
  position: absolute;
  bottom: 20px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.text-content {
  flex: 1;
  margin-bottom: 50px;
  p {
    font-size: 58px;
    line-height: 48px;
    margin: 0 0 10px 0;
  }

  .ms {
    font-size: 30px;
    line-height: 32px;
  }
}

.qr-content {
  width: 185px;
  height: 185px;
  flex-shrink: 0;
  margin-right: 120px;
  margin-bottom: 40px;
  
  #qrcode {
    width: 185px;
    height: 185px;
  }
}
.ide {
  display: inline-block;
  width: 645px;
}
.meng {
  height: 1475px;
  width: 1125px;
  position: absolute;
  top: 0px;
  z-index: 0;
  background: rgba(#040000, 0.6);
}
.text {
  width: 100%;
  min-height: 350px;
  max-height: 600px;
  font-size: 130px;
  background-color: white;
  position: absolute;
  top: 1125px;
  font-weight: bold;
  mix-blend-mode: plus-lighter;
  justify-content: center;
  align-items: center;
  display: flex;
  padding: 20px;
  word-wrap: break-word;
  overflow: hidden;
}
</style>
